<div class="dialog-container">
  <h2 mat-dialog-title>{{ isEditMode ? 'Edit' : 'Add' }} Adventure Program</h2>

  <mat-dialog-content>
    <form [formGroup]="programForm" class="form-container">
      <!-- Image Upload -->
      <div class="form-section">
        <h3>Program Image</h3>
        <div class="image-section">
          <div class="image-controls">
            <mat-form-field appearance="outline">
              <mat-label>Image</mat-label>
              <input matInput [formControl]="imageControl" (keyup)="resetImage()"
                placeholder="Enter image ID or upload new image">
            </mat-form-field>
            <button mat-raised-button color="primary" (click)="verifyImage()" [disabled]="!imageControl.value">Verify
              Image</button>
          </div>
          <div class="image-preview" *ngIf="toVerify">
            <app-image-uploader [imageId]="imageVerify" (uploadFiles)="setFile($event)"
              (exists)="setImage($event)"></app-image-uploader>
          </div>
        </div>
      </div>

      <!-- Basic Information -->
      <div class="form-section">
        <h3>Basic Information</h3>
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" required>
          <mat-error *ngIf="programForm.get('name')?.hasError('required')">
            Name is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <textarea matInput formControlName="description" required></textarea>
          <mat-error *ngIf="programForm.get('description')?.hasError('required')">
            Description is required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Program Details -->
      <div class="form-section">
        <h3>Program Details</h3>
        <mat-form-field appearance="outline">
          <mat-label>Target Ages</mat-label>
          <mat-select multiple formControlName="ages" required>
            <mat-option *ngFor="let age of ageOptions" [value]="age">
              {{ age }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="programForm.get('targetAge')?.hasError('required')">
            Target age is required
          </mat-error>
        </mat-form-field>

        <div class="form-group">
          <label for="arcadeType">Building</label>
          <mat-form-field appearance="outline" class="w-100">
            <mat-select id="arcadeType" formControlName="arcadeType"
              (selectionChange)="onArcadeTypeChange($event.value)" required>
              <mat-option *ngFor="let type of arcadeTypeOptions" [value]="type">
                {{formatArcadeType(type)}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="programForm.get('arcadeType')?.hasError('required')">
              Building is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-group">
          <label>Priority</label>
          <div class="priority-container">
            <input type="range" [min]="0" [max]="4" [step]="1" [value]="selectedPriority"
              (input)="onPriorityChange($any($event).target.value)" class="priority-slider">
            <div class="priority-indicator" [style.background-color]="priorityColors[selectedPriority]">
              {{ priorityLabels[selectedPriority] }}
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="customArcadeType">
          <label for="customArcadeType">Custom Building</label>
          <mat-form-field appearance="outline" class="w-100">
            <input matInput id="customArcadeType" [formControl]="customArcadeControl"
              (input)="onCustomArcadeTypeChange(customArcadeControl.value || '')" placeholder="Enter custom arcade type"
              required>
            <mat-error *ngIf="!customArcadeControl.hasError('required')">
              Custom building is required
            </mat-error>
          </mat-form-field>
        </div>

      </div>

      <!-- Adventures -->
      <div class="form-section">
        <h3>Adventures</h3>
        <div class="tag-select-container">
          <div class="tag-selector-container">
            <mat-form-field appearance="outline" class="filter-field">
              <mat-label>Filter adventures</mat-label>
              <input matInput (keyup)="filterAdventures($event)" placeholder="Search adventures...">
            </mat-form-field>

            <div class="list adventure-picker">
              <div class="loading" *ngIf="adventuresLoading">
                <mat-spinner></mat-spinner>
              </div>
              <div class="list-item" *ngFor="let adventure of filteredAdventures">
                <div class="item-text">{{ adventure.name }}</div>
                <div>
                  <button mat-mini-fab color="primary" [disabled]="isAdventureSelected(adventure)"
                    (click)="onAdventureSelected(adventure)">
                    <mat-icon>arrow_forward</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="tag-list-container">
            <div class="list">
              <div class="list-item" *ngFor="let adventure of selectedAdventures; let adventureIndex = index">
                <div class="item-text">{{ adventure.name }}</div>
                <div>
                  <button mat-icon-button color="primary" (click)="removeAdventure(adventureIndex)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
      <mat-checkbox [checked]="isPublished" (change)="onPublishChange($event)">Publish Program</mat-checkbox>
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="!programForm.valid || loading" (click)="onSubmit()">
        {{ isEditMode ? 'Update' : 'Create' }}
      </button>
  </mat-dialog-actions>
</div>